/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function ConditionalTemplatesEditViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,
    BreadcrumbService: JS5Object,
    ConditionalTemplatesService: JS5Object,
    ModalService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
) {
    this.editData = {
    };
    const getData = () => {
        this.loadingIndicator.show = true;
        ConditionalTemplatesService.getConditionalTemplate($routeParams.id).then((conditionalTemplate: JS5Object) => {
            ConditionalTemplatesService.originalEditData = _.cloneDeep(conditionalTemplate);
            this.editData = conditionalTemplate;
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const saveHandler = () => {
        this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewConditionalTemplate();
        }
        else {
            updateConditionalTemplate();
        }
    };

    const updateConditionalTemplate = () => {
        ConditionalTemplatesService.updateConditionalTemplate(this.editData).then((conditionalTemplate: JS5Object) => {
            ConditionalTemplatesService.originalEditData = _.cloneDeep(conditionalTemplate);
            this.editData = conditionalTemplate;
            this.editorForm.$setPristine();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };
    const saveNewConditionalTemplate = () => {
        ConditionalTemplatesService.createConditionalTemplate(this.editData).then((conditionalTemplate: JS5Object) => {
            $route.updateParams({id: conditionalTemplate.id});
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine') && _.get(this.editorForm, '$valid'),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(ConditionalTemplatesService.originalEditData);
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/templates/search`).search({tab: 'ConditionalTemplates'})
        }
    ];


    this.$onInit = () => {
        SidebarService.editService = ConditionalTemplatesService;
        this.isAdmin = PermissionsService.isAdmin();
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Conditional Template',
                        location: '/system/templates/search',
                        params: {tab: 'ConditionalTemplates'}
                    });
                }
                getData();
            } else {
                ConditionalTemplatesService.originalEditData = _.cloneDeep(this.editData);
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Conditional Template',
                    location: '/system/templates/search',
                    params: {tab: 'ConditionalTemplates'}
                });
            }
        } else {
            $location.url('/login');
        }
    };

    this.$onDestroy = () => {
        ConditionalTemplatesService.originalEditData = null;
        ConditionalTemplatesService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            ConditionalTemplatesService.editorForm = this.editorForm;
            BreadcrumbService.editService = ConditionalTemplatesService;
        });
    };
}


angular.module('prism-ui.conditionalTemplate').component('conditionalTemplatesEditView', {
    templateUrl: 'system/templates/conditionalTemplate/editor/conditional-template-edit-template.html',
    controller: ConditionalTemplatesEditViewController,
    bindings: {
    }
});
